module.exports = __webpack_public_path__ + "static/sixth_user_image3-07b26377161f2347f302c6086bd5e8f0.jpg";